module.exports = __webpack_public_path__ + "static/media/book6cover_preview.3fe7918d.png";